import * as React from "react"

import
  { IOWidget
  , Options
  , mk_widget
  , Widget
  } from "../widget"

interface MovableProps
  { x : number
  , y : number
  }

/** @deprecated Use [[wrapHTML]] instead. */
export const movable = function<A>
  ( innerWidget : Widget<{}>
  , props       : MovableProps
  , options?    : Options
  ) : IOWidget<A, A> {
  
  const style: React.CSSProperties =
    { transform : `translate(${props.x}px, ${props.y}px)`
    , position  : "relative"
    }

  return i =>
    mk_widget(
      { options
      , run: (onDone: (o: A) => void) =>
      <div { ...options } style={style} >
        {innerWidget.run(_ => ({}))}
      </div>
    })
}
